import CekKeluarMasukArsipMain from "../../features/cek-keluar-masuk/cek-keluar-masuk-mobil/cek-keluar-masuk-mobil-arsip/component/CekKeluarMasukArsipMain";

const CekKeluarMasukArsipPage = () => {
  return <CekKeluarMasukArsipMain />;
};

export default CekKeluarMasukArsipPage;
